import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BudgetForm } from "./components";
import reportWebVitals from "./reportWebVitals";
import { BackgroundIcons } from "./components/background";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BackgroundIcons />
    <BudgetForm />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
